'use client';

import { useDecisions } from '../../hooks';
import { BazaarVoiceLegacy } from './BazaarVoice.legacy';

export function BazaarVoiceScript() {
    const isOneTrust = useDecisions('onetrust');

    if (isOneTrust) return null;

    return <BazaarVoiceLegacy />;
}
